import { render } from "./App.vue?vue&type=template&id=477a6034&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=477a6034&lang=scss"
import "./App.vue?vue&type=style&index=1&id=477a6034&scoped=true&lang=scss"

import exportComponent from "/Users/ondrej/dev/www/_showheroes/2023/norway/helthjem-w49/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477a6034"]])

export default __exports__